(function () {
  'use strict';

  function scrollBehavior() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'instant'
      : 'smooth';
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-vikis-calculator]').forEach(initCalculator);
  });

  function initCalculator(root) {
    if (!window.VikisCalculatorCore || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var core = window.VikisCalculatorCore;
    var basket = window.VikisCalculatorBasket;
    var form = root.querySelector('[data-calculator-form]');
    var results = root.querySelector('[data-results]');
    var catalogCache = {};
    var catalogUrls = JSON.parse(root.querySelector('[data-checkout-catalog-urls]').textContent);
    var checkoutMessages = JSON.parse(root.querySelector('[data-checkout-messages]').textContent);
    var addInProgress = false;
    var currentPlan = 'full';
    var currentResult = null;
    var lastInput = null;
    var petPosition = 1;
    var petId = null;
    var petIdentity = null;
    var cartState = { pets: [], issues: [], nextPosition: 1, nextOrder: 1 };
    var cartReadSequence = 0;
    var hasCalculated = false;
    var profileManager = null;
    var calculationPending = false;
    var calculationTimer = null;
    var calculationRevision = 0;
    var cartController = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    var nameInput = form.elements.petName;
    var weightInput = form.elements.weightKg;
    var speciesInputs = form.elements.species;
    var customInput = root.querySelector('[data-custom-portion]');
    var customToggle = root.querySelector('[data-custom-toggle]');
    var liveStatus = root.querySelector('[data-live-status]');
    var resultNote = root.querySelector('[data-result-note]');
    var resultNoteDefault = resultNote ? resultNote.textContent : '';
    var messageNode = root.querySelector('[data-calculator-messages]');
    var calculatorMessages = JSON.parse(messageNode && messageNode.textContent || '{}');
    var incompleteMessage = calculatorMessages.incomplete || 'Complete the highlighted details to update the plans.';

    nameInput.addEventListener('input', updatePersonalization);
    weightInput.addEventListener('input', updateWeightNote);
    Array.from(speciesInputs).forEach(function (input) {
      input.addEventListener('change', updateSpeciesFields);
    });
    form.addEventListener('input', function (event) {
      updateWeightNote();
      if (!event.target || event.target.type === 'radio' || event.target.type === 'checkbox' || event.isComposing) return;
      scheduleCalculation(250);
    });
    form.addEventListener('change', function () { updateHealthFields(); scheduleCalculation(0); });
    form.addEventListener('compositionend', function () { scheduleCalculation(250); });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      calculationRevision++;
      if (!recalculate(true)) return;
      hasCalculated = true;
      setProgressStep('plans');
      results.hidden = false;
      results.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      refreshCartState().catch(function () {});
    });

    root.querySelectorAll('[data-plan]').forEach(function (button) {
      button.addEventListener('click', function () {
        activatePlan(button.dataset.plan);
      });
    });

    customInput.addEventListener('input', function () {
      if (!customToggle.checked) return;
      scheduleCalculation(250);
    });
    customInput.addEventListener('change', function () { if (customToggle.checked) scheduleCalculation(0); });

    customToggle.addEventListener('change', function () {
      if (!hasCalculated) return;
      if (customToggle.checked && !customInput.value && currentResult) customInput.value = currentResult.displayRecommendedPortionGrams;
      activatePlan(currentPlan);
      if (customToggle.checked) customInput.focus();
    });

    root.querySelectorAll('[data-add-category]').forEach(function (button) {
      button.addEventListener('click', function () {
        addCategoryToBasket(button.dataset.addCategory, button);
      });
    });

    root.querySelector('[data-edit-details]').addEventListener('click', function () {
      setProgressStep('details');
      form.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
      nameInput.focus({ preventScroll: true });
    });

    root.querySelector('[data-add-another-pet]').addEventListener('click', function () {
      petId = null;
      petIdentity = null;
      cancelCalculation();
      calculationRevision++;
      hasCalculated = false;
      petPosition = cartState.nextPosition;
      form.reset();
      if (profileManager) profileManager.reset();
      form.elements.species.value = 'dog';
      form.elements.activity.value = 'moderate';
      form.elements.bodyCondition.value = 'unsure';
      currentPlan = 'full';
      customToggle.checked = false;
      customInput.value = '';
      currentResult = null;
      lastInput = null;
      results.hidden = true;
      root.querySelector('[data-basket-success]').hidden = true;
      if (liveStatus) liveStatus.textContent = '';
      if (resultNote) resultNote.textContent = resultNoteDefault;
      clearErrors();
      setProgressStep('details');
      updatePersonalization();
      updateSpeciesFields();
      updateWeightNote();
      updateHealthFields();
      root.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      window.setTimeout(function () { nameInput.focus(); }, 500);
      refreshCartState().catch(function () {});
    });

    updatePersonalization();
    updateSpeciesFields();
    updateWeightNote();
    updateHealthFields();
    if (window.VikisPetProfiles) {
      profileManager = window.VikisPetProfiles.attach(root, form, function (savedId) {
        petId = savedId;
        petIdentity = basket.identity(nameInput.value, form.elements.species.value);
        cancelCalculation();
        calculationRevision++;
        hasCalculated = false;
        currentResult = null;
        lastInput = null;
        customToggle.checked = false;
        customInput.value = '';
        results.hidden = true;
        clearErrors();
        updatePersonalization();
        updateSpeciesFields();
        updateWeightNote();
        updateHealthFields();
        setProgressStep('details');
        refreshCartState().catch(function () {});
      });
    }
    refreshCartState().catch(function () {});

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      var unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source !== 'vikis-calculator') return refreshCartState().catch(function () {});
      });
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target && event.target.contains(root)) unsubscribe();
      });
    }
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains(root)) {
        cancelCalculation();
        hasCalculated = false;
      }
    });

    function invalidCustomPortion() {
      return Boolean(customToggle.checked && (!Number.isFinite(Number(customInput.value)) || Number(customInput.value) <= 0 || (customInput.validity && customInput.validity.badInput)));
    }

    function cancelCalculation() {
      if (calculationTimer !== null) window.clearTimeout(calculationTimer);
      calculationTimer = null;
      calculationPending = false;
      results.removeAttribute('aria-busy');
    }

    function updateAddButtons() {
      root.querySelectorAll('[data-add-category]').forEach(function (button) {
        button.disabled = addInProgress || calculationPending || !currentResult || !lastInput || invalidCustomPortion();
      });
    }

    function invalidateResult(message) {
      currentResult = null;
      lastInput = null;
      cancelCalculation();
      if (resultNote) resultNote.textContent = message;
      if (liveStatus) liveStatus.textContent = message;
      root.querySelector('[data-result-name]').textContent = nameInput.value.trim() || 'Your pet';
      root.querySelector('[data-result-context]').textContent = '';
      root.querySelector('[data-recommended-portion]').textContent = '—';
      root.querySelector('[data-package-note]').textContent = '';
      root.querySelector('[data-review-note]').hidden = true;
      root.querySelector('[data-basket-success]').hidden = true;
      root.querySelectorAll('[data-species-card]').forEach(function (card) {
        card.querySelector('[data-card-price]').textContent = '—';
        card.querySelector('[data-mapping-note]').hidden = true;
      });
      updateAddButtons();
    }

    function scheduleCalculation(delay) {
      if (!hasCalculated) return;
      cancelCalculation();
      calculationRevision++;
      root.querySelector('[data-basket-success]').hidden = true;
      clearErrors();
      if (!validateForm(false)) {
        invalidateResult(incompleteMessage);
        return;
      }
      if (invalidCustomPortion() || !delay) {
        recalculate(false);
        return;
      }
      calculationPending = true;
      results.setAttribute('aria-busy', 'true');
      if (resultNote) resultNote.textContent = calculatorMessages.updating || 'Updating plans…';
      updateAddButtons();
      calculationTimer = window.setTimeout(function () { recalculate(false); }, delay);
    }

    function recalculate(reportErrors) {
      cancelCalculation();
      clearErrors();
      if (!validateForm(reportErrors)) {
        if (hasCalculated) invalidateResult(incompleteMessage);
        return false;
      }
      try {
        lastInput = collectInput();
        syncPetIdentity(lastInput);
        currentResult = core.calculate(lastInput);
        if (profileManager) profileManager.remember(lastInput, petId);
        if (resultNote) resultNote.textContent = resultNoteDefault;
        renderResults();
        if (liveStatus) liveStatus.textContent = invalidCustomPortion()
          ? root.querySelector('[data-custom-error]').textContent
          : (calculatorMessages.updated || 'Plans updated.');
        return !invalidCustomPortion();
      } catch (error) {
        invalidateResult(error.message || incompleteMessage);
        if (reportErrors) showFormError(error.message || incompleteMessage);
        return false;
      }
    }

    function route(path) {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + path;
    }

    function syncPetIdentity(input) {
      var identity = basket.identity(input.petName, input.species);
      if (petId && petIdentity && petIdentity !== identity) {
        petId = null;
        if (profileManager) profileManager.reset();
      }
      petIdentity = identity;
    }

    function newPetId() {
      return window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : 'pet-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }

    async function readCart() {
      if (!basket) throw new Error(checkoutMessages.cartLoadFailed || checkoutMessages.loadFailed);
      var sequence = ++cartReadSequence;
      try {
        var response = await fetch(route('cart.js'), { cache: 'no-store', headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error();
        var cart = await response.json();
        var state = basket.inspect(cart);
        if (sequence === cartReadSequence) cartState = state;
        return { cart: cart, state: state };
      } catch (error) {
        throw new Error(checkoutMessages.cartLoadFailed || checkoutMessages.loadFailed);
      }
    }

    async function refreshCartState() {
      var result = await readCart();
      if (result.state !== cartState || addInProgress) return;
      var input = lastInput || { petName: nameInput.value, species: form.elements.species.value };
      syncPetIdentity(input);
      var pet = basket.resolvePet(cartState, input, petId);
      petPosition = pet.position;
      if (pet.existing) petId = pet.id;
      if (lastInput && currentResult && !calculationPending && lastInput.petPosition !== petPosition) {
        lastInput.petPosition = petPosition;
        currentResult = core.calculate(lastInput);
        renderResults();
      }
    }

    function updatePersonalization() {
      var name = nameInput.value.trim();
      root.querySelector('[data-dynamic-heading]').textContent = name
        ? 'Build A Meal Plan Around ' + name
        : 'Build A Meal Plan For Your Pet';
      root.querySelector('[data-form-heading]').textContent = name
        ? "Let's Get To Know " + name
        : "Let's Get To Know Your Pet";
      root.querySelector('[data-submit-label]').textContent = name
        ? "See " + name + "'s Plan"
        : "See Your Pet's Plan";
    }

    function updateWeightNote() {
      // Retained call site for the live-update flow; the redundant grams helper was removed.
      var youngNote = root.querySelector('[data-young-note]');
      if (youngNote) youngNote.hidden = form.elements.ageYears.value.trim() === '' || Number(form.elements.ageYears.value) >= 1;
    }

    function updateSpeciesFields() {
      var species = form.elements.species.value;
      root.querySelector('[data-dog-activity]').hidden = species !== 'dog';
      root.querySelector('[data-dog-condition]').hidden = species !== 'dog';
    }

    function validateForm(reportErrors) {
      var valid = true;
      var ageYearsValue = form.elements.ageYears.value.trim();
      var ageMonthsValue = form.elements.ageMonths.value.trim();
      var ageYears = Number(ageYearsValue);
      var ageMonths = ageMonthsValue === '' ? 0 : Number(ageMonthsValue);
      var required = [
        ['petName', nameInput.value.trim(), "Please enter your pet's name."],
        ['ageYears', ageYearsValue !== '' && Number.isInteger(ageYears) && ageYears >= 0, 'Please enter age in whole years. Use 0 for a pet under one year old.'],
        ['ageMonths', ageMonthsValue === '' || (Number.isInteger(ageMonths) && ageMonths >= 0 && ageMonths <= 11), 'Please enter months from 0 to 11.'],
        ['weightKg', Number.isFinite(Number(weightInput.value)) && Number(weightInput.value) > 0, 'Please enter a valid weight.']
      ];

      ['healthNotes', 'allergyNotes'].forEach(function (name) {
        var field = form.elements[name];
        var selected = form.elements[name === 'healthNotes' ? 'hasHealthNeeds' : 'hasDietaryRestrictions'].checked;
        if (field && selected) required.push([name, field.value.trim().length > 0 && field.value.trim().length <= 500,
          calculatorMessages[name + 'Required'] || 'Please describe these needs (up to 500 characters).']);
      });

      required.forEach(function (field) {
        var input = form.elements[field[0]];
        if (!field[1] || (input.validity && input.validity.badInput)) {
          setError(field[0], field[2]);
          valid = false;
        }
      });

      if (!valid && reportErrors !== false) {
        showFormError('Please complete the highlighted details.');
        var firstError = form.querySelector('[aria-invalid="true"]');
        if (firstError) firstError.focus();
      }

      return valid;
    }

    function collectInput() {
      return {
        petName: nameInput.value.trim(),
        species: form.elements.species.value,
        ageYears: Number(form.elements.ageYears.value),
        ageMonths: form.elements.ageMonths.value === '' ? null : Number(form.elements.ageMonths.value),
        weightKg: Number(form.elements.weightKg.value),
        activity: form.elements.species.value === 'dog' ? form.elements.activity.value : undefined,
        bodyCondition: form.elements.species.value === 'dog' ? form.elements.bodyCondition.value : undefined,
        hasHealthNeeds: form.elements.hasHealthNeeds.checked,
        hasDietaryRestrictions: form.elements.hasDietaryRestrictions.checked,
        healthNotes: form.elements.hasHealthNeeds.checked && form.elements.healthNotes ? form.elements.healthNotes.value.trim() : '',
        allergyNotes: form.elements.hasDietaryRestrictions.checked && form.elements.allergyNotes ? form.elements.allergyNotes.value.trim() : '',
        petPosition: petPosition,
        customPortionGrams: customToggle.checked && !invalidCustomPortion()
          ? Number(customInput.value)
          : undefined
      };
    }

    function updateHealthFields() {
      ['healthNotes', 'allergyNotes'].forEach(function (name) {
        var field = form.elements[name];
        if (!field) return;
        var selected = form.elements[name === 'healthNotes' ? 'hasHealthNeeds' : 'hasDietaryRestrictions'].checked;
        root.querySelector('[data-details-for="' + name + '"]').hidden = !selected;
        field.required = selected;
        field.disabled = !selected;
      });
    }

    function activatePlan(plan) {
      currentPlan = plan;
      root.querySelectorAll('[data-plan]').forEach(function (button) {
        var active = button.dataset.plan === plan;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      root.querySelector('[data-selected-plan-summary]').textContent = planSummary(plan, true);

      var customPanel = root.querySelector('[data-custom-portion-panel]');
      customPanel.hidden = !customToggle.checked;
      customToggle.setAttribute('aria-expanded', String(customToggle.checked));

      if (hasCalculated) {
        calculationRevision++;
        recalculate(false);
      }
    }

    function renderResults() {
      if (!currentResult || !lastInput) return;
      var invalidCustom = invalidCustomPortion();
      root.querySelector('.vpc__food-grid').hidden = invalidCustom;
      root.querySelector('[data-custom-error]').hidden = !invalidCustom;
      if (!invalidCustom) customInput.removeAttribute('aria-invalid');
      if (invalidCustom) {
        customInput.setAttribute('aria-invalid', 'true');
        root.querySelector('[data-custom-error]').textContent = 'Enter a portion above 0g to see its prices.';
      }
      updateAddButtons();

      var name = lastInput.petName;
      root.querySelector('[data-result-name]').textContent = name;
      root.querySelector('[data-result-context]').textContent = "Based on " + name + "'s details";
      root.querySelector('[data-recommended-portion]').textContent = formatNumber(currentResult.displayRecommendedPortionGrams, 0) + ' g';
      root.querySelector('[data-review-note]').hidden = !currentResult.needsManualReview;
      var hasSmallPortion = currentResult.reviewReasons.includes('small-portion');
      root.querySelector('[data-review-copy]').textContent = hasSmallPortion
        ? "Our smallest package is " + currentResult.minimumPackageGrams + "g. We'll contact you to confirm the right feeding portion, recipes and price for " + name + '.'
        : 'You can still compare starting prices and continue, but the final portion, recipes or price may need individual adjustment.';
      if (invalidCustom) {
        root.querySelector('[data-package-note]').textContent = '';
        return;
      }
      var packageNote = root.querySelector('[data-package-note]');
      packageNote.textContent = (hasSmallPortion ? 'Starting prices based on ' : 'Prices based on ')
        + currentResult.packagePortionGrams + 'g per package.';
      if (customToggle.checked) {
        packageNote.textContent += ' Your selected feeding portion: ' + currentResult.displaySelectedPortionGrams + 'g/day.';
      }
      var selectedSummary = planSummary(currentPlan, true);
      if (currentResult.belowMinimumPackage) selectedSummary = selectedSummary.replace(/meals/g, 'packs');
      root.querySelector('[data-selected-plan-summary]').textContent = selectedSummary;

      root.querySelectorAll('[data-species-card]').forEach(function (card) {
        card.hidden = !currentResult.categories.some(function (category) {
          return category.id === card.dataset.categoryCard;
        });
      });

      currentResult.categories.forEach(function (category) {
        var card = root.querySelector('[data-category-card="' + category.id + '"]');
        if (!card) return;

        var price = category.selectedPrices[currentPlan];
        card.querySelector('[data-card-price]').textContent = formatNumber(price, price % 1 === 0 ? 0 : 2);
        var cycle = cycleLabel(currentPlan);
        var summary = planSummary(currentPlan, false);
        if (currentResult.belowMinimumPackage) {
          cycle = cycle.replace(/meal/g, 'pack');
          summary = summary.replace(/meals/g, 'packs');
        }
        card.querySelector('[data-price-cycle]').textContent = cycle;
        card.querySelector('[data-card-plan-summary]').textContent = summary;

        var addButton = card.querySelector('[data-add-category]');
        addButton.hidden = false;
        addButton.setAttribute('aria-label', 'Add ' + planName(currentPlan) + ' in ' + category.name + ' for ' + name + ' to basket');

        card.querySelector('[data-mapping-note]').hidden = true;
      });
    }

    async function addCategoryToBasket(categoryId, button) {
      if (addInProgress || calculationPending || !currentResult || !lastInput) return;
      if (customToggle.checked && (!Number.isFinite(Number(customInput.value)) || Number(customInput.value) <= 0)) return;
      var category = currentResult.categories.find(function (item) { return item.id === categoryId; });
      if (!category) return;

      var price = category.selectedPrices[currentPlan];
      var card = button.closest('[data-category-card]');
      var mappingNote = card.querySelector('[data-mapping-note]');
      var inputSnapshot = Object.assign({}, lastInput);
      var resultSnapshot = currentResult;
      var planSnapshot = currentPlan;
      syncPetIdentity(inputSnapshot);
      if (!petId) petId = newPetId();
      var petIdSnapshot = petId;
      var petName = lastInput.petName;
      var revisionSnapshot = calculationRevision;

      var originalLabel = button.textContent;
      addInProgress = true;
      updateAddButtons();
      mappingNote.hidden = true;
      root.querySelector('[data-basket-success]').hidden = true;
      button.disabled = true;
      button.textContent = 'Adding…';

      try {
        var basketResult = await readCart();
        var pet = basket.resolvePet(basketResult.state, inputSnapshot, petIdSnapshot);
        if (pet.existing || pet.ambiguous) throw new Error(checkoutMessages.alreadyAdded || checkoutMessages.addFailed);
        var catalog = await loadCatalog(categoryId);
        if (!catalog.checkoutEnabled || catalog.status === 'DRAFT') throw new Error(checkoutMessages.pendingApproval);
        var reconciliation = basket.reconciliationPlan(basketResult.cart, core);
        if (reconciliation.requiresReview) throw new Error(checkoutMessages.cartReviewRequired || checkoutMessages.addFailed);
        var freshInput = Object.assign({}, inputSnapshot, { petPosition: pet.position });
        var freshResult = core.calculate(freshInput);
        var freshCategory = freshResult.categories.find(function (item) { return item.id === categoryId; });
        if (!freshCategory) throw new Error(checkoutMessages.unmatchedPrice);
        if (freshCategory.selectedPrices[planSnapshot] !== price) {
          if (lastInput === null || lastInput.petName !== inputSnapshot.petName) throw new Error(checkoutMessages.cartChanged || checkoutMessages.addFailed);
          petPosition = pet.position;
          lastInput.petPosition = petPosition;
          currentResult = core.calculate(lastInput);
          renderResults();
          throw new Error(checkoutMessages.cartChanged || checkoutMessages.addFailed);
        }
        resultSnapshot = freshResult;
        inputSnapshot = freshInput;
        var addedPetId = pet.id || newPetId();
        if (petId === petIdSnapshot) petId = addedPetId;
        var properties = lineItemProperties(category, inputSnapshot, resultSnapshot, planSnapshot);
        properties._vikis_calculator = '2';
        properties._vikis_pet_id = addedPetId;
        properties._vikis_profile_version = '1';
        properties._vikis_age_years = String(inputSnapshot.ageYears);
        properties._vikis_age_months = inputSnapshot.ageMonths === null ? '' : String(inputSnapshot.ageMonths);
        properties._vikis_weight_kg = String(inputSnapshot.weightKg);
        properties._vikis_health_needs = inputSnapshot.hasHealthNeeds ? 'Yes' : 'No';
        properties._vikis_dietary_restrictions = inputSnapshot.hasDietaryRestrictions ? 'Yes' : 'No';
        properties._vikis_pet_order = String(pet.order);
        properties._vikis_category = categoryId;
        properties._vikis_plan = planSnapshot;
        properties._vikis_package_grams = String(resultSnapshot.packagePortionGrams);
        var variant = core.checkoutVariant(catalog, categoryId, price);
        if (!variant) throw new Error(checkoutMessages.unmatchedPrice);
        var sectionIds = cartController && typeof cartController.getSectionsToRender === 'function'
          ? cartController.getSectionsToRender().map(function (section) { return section.id; }).slice(0, 5)
          : ['cart-icon-bubble'];
        if (cartController && typeof cartController.setActiveElement === 'function') cartController.setActiveElement(button);
        var response = await fetch(route('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [{
              id: variant.id,
              quantity: 1,
              properties: properties
            }],
            sections: sectionIds,
            sections_url: window.location.pathname + window.location.search
          })
        });

        var added = await response.json();
        if (!response.ok) throw new Error(checkoutMessages.addFailed);
        var addedItem = added.items && added.items.find(function (item) { return String(item.variant_id || item.id) === variant.id; });
        if (!addedItem) throw new Error(checkoutMessages.confirmFailed);
        if (profileManager && calculationRevision === revisionSnapshot) profileManager.remember(inputSnapshot, addedPetId);

        var synchronized = await synchronizeBasket(added, addedItem, sectionIds);

        var success = root.querySelector('[data-basket-success]');
        success.querySelector('[data-basket-success-title]').textContent = category.name + ' for ' + petName + ' was added to your basket.';
        success.hidden = false;
        if (calculationRevision === revisionSnapshot) {
          setProgressStep('basket');
          success.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
        }
        if (!synchronized) {
          mappingNote.hidden = false;
          mappingNote.textContent = checkoutMessages.cartRefreshFailed || checkoutMessages.confirmFailed;
        }
      } catch (error) {
        mappingNote.hidden = false;
        mappingNote.textContent = error.message || 'We could not add this plan. Please try again.';
      } finally {
        addInProgress = false;
        updateAddButtons();
        button.textContent = originalLabel;
      }
    }

    async function synchronizeBasket(added, addedItem, sectionIds) {
      var synchronized = true;
      try {
        var sections = added.sections;
        if (!sections || sectionIds.some(function (id) { return typeof sections[id] !== 'string'; })) {
          var url = new URL(window.location.href);
          url.searchParams.set('sections', sectionIds.join(','));
          var response = await fetch(url.pathname + url.search, { cache: 'no-store', headers: { 'Accept': 'application/json' } });
          if (!response.ok) throw new Error();
          sections = await response.json();
        }
        if (!sections || sectionIds.some(function (id) { return typeof sections[id] !== 'string'; })) throw new Error();
        if (cartController && typeof cartController.renderContents === 'function') {
          cartController.classList.remove('is-empty');
          cartController.renderContents(Object.assign({}, addedItem, { sections: sections }));
        } else {
          var icon = document.getElementById('cart-icon-bubble');
          var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (!icon || !parsed) throw new Error();
          icon.innerHTML = parsed.innerHTML;
        }
      } catch (error) {
        synchronized = false;
      }
      try {
        await readCart();
      } catch (error) {
        synchronized = false;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vikis-calculator', productVariantId: String(addedItem.variant_id || addedItem.id), cartData: added
          })).catch(function () {});
        } catch (error) {}
      }
      return synchronized;
    }

    async function loadCatalog(categoryId) {
      if (catalogCache[categoryId]) return catalogCache[categoryId];
      var url = catalogUrls[categoryId];
      if (!url) throw new Error(checkoutMessages.loadFailed);
      var response = await fetch(url, { cache: 'no-store', headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error(checkoutMessages.loadFailed);
      var catalog = await response.json();
      if (catalog.categoryId !== categoryId || catalog.currency !== 'JOD') throw new Error(checkoutMessages.loadFailed);
      catalogCache[categoryId] = catalog;
      return catalog;
    }

    function lineItemProperties(category, input, result, plan) {
      return {
        '_Pet': input.petName + ' · ' + capitalize(result.species),
        '_Pet age': formatAge(input.ageYears, input.ageMonths),
        '_Pet weight': formatNumber(result.weightKg, 2) + ' kg',
        '_Activity level': result.species === 'dog' ? capitalize(input.activity) : 'Not used for cat calculation',
        '_Body condition': result.species === 'dog' ? capitalize(input.bodyCondition || 'unsure') : 'Not provided',
        '_Health needs': input.hasHealthNeeds ? (input.healthNotes || 'Yes — details not provided') : 'None reported',
        '_Allergies / dietary restrictions': input.hasDietaryRestrictions ? (input.allergyNotes || 'Yes — details not provided') : 'None reported',
        '_Food': category.name,
        'Plan': planName(plan),
        '_Daily portion': result.displaySelectedPortionGrams + ' g/day',
        'Package size': result.packagePortionGrams + ' g',
        '_Plan includes': planSummary(plan, false),
        '_vikis_pet_name': input.petName,
        '_vikis_pet_type': capitalize(result.species),
        '_vikis_exact_age': formatAge(input.ageYears, input.ageMonths),
        '_vikis_exact_weight': formatNumber(result.weightKg, 2) + ' kg (' + result.weightGrams + ' g)',
        '_vikis_activity': result.species === 'dog' ? capitalize(input.activity) : 'Not used for cat calculation',
        '_vikis_body_condition': result.species === 'dog' ? capitalize(input.bodyCondition || 'unsure') : 'Manual if needed',
        '_vikis_recommended_portion': result.displayRecommendedPortionGrams + ' g/day',
        '_vikis_selected_portion': result.displaySelectedPortionGrams + ' g/day',
        '_vikis_package_size': result.packagePortionGrams + ' g',
        '_vikis_pricing_status': result.needsManualReview ? 'Estimate; personal confirmation required' : 'Standard plan',
        '_vikis_packaging': result.packaging === 'plastic-packet' ? 'Plastic packets' : 'Vacuum bags',
        '_vikis_manual_confirmation': result.needsManualReview ? 'Yes' : 'No',
        '_vikis_pet_position': String(result.petPosition),
        '_vikis_discount_rate': '0%'
      };
    }

    function setError(fieldName, message) {
      var field = form.elements[fieldName];
      var error = form.querySelector('[data-error-for="' + fieldName + '"]');
      if (field) field.setAttribute('aria-invalid', 'true');
      if (error) error.textContent = message;
    }

    function clearErrors() {
      form.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
        field.removeAttribute('aria-invalid');
      });
      form.querySelectorAll('[data-error-for]').forEach(function (error) {
        error.textContent = '';
      });
      root.querySelector('[data-form-error]').hidden = true;
    }

    function showFormError(message) {
      var error = root.querySelector('[data-form-error]');
      error.textContent = message;
      error.hidden = false;
    }

    function setProgressStep(step) {
      var order = ['details', 'plans', 'basket'];
      var activeIndex = order.indexOf(step);

      root.querySelectorAll('[data-step]').forEach(function (item) {
        var itemIndex = order.indexOf(item.dataset.step);
        item.classList.toggle('is-active', itemIndex === activeIndex);
        item.classList.toggle('is-complete', itemIndex < activeIndex);
        if (itemIndex === activeIndex) {
          item.setAttribute('aria-current', 'step');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    }
  }

  function cycleLabel(plan) {
    if (plan === 'mix') return '/ 15-meal plan';
    if (plan === 'trial') return '/ 7-meal trial';
    if (plan === 'custom') return '/ 30 custom meals';
    return '/ 30-meal plan';
  }

  function planSummary(plan, includeSelected) {
    var summary;
    if (plan === 'mix') summary = 'Mix Feeding · 15 meals · 2 deliveries · 2 recipes';
    else if (plan === 'trial') summary = 'One-Week Trial · 7 meals · 1 delivery · 1 recipe';
    else if (plan === 'custom') summary = 'Custom Portion · 30 custom-sized meals · 4 deliveries · 4 recipes';
    else summary = 'Full Feeding · 30 meals · 4 deliveries · 4 recipes';
    return includeSelected ? summary + ' selected' : summary;
  }

  function planName(plan) {
    if (plan === 'mix') return 'Mix Feeding';
    if (plan === 'trial') return 'One-Week Trial';
    if (plan === 'custom') return 'Custom Portion';
    return 'Full Feeding';
  }

  function formatAge(yearsValue, monthsValue) {
    var years = Number(yearsValue);
    var hasMonths = monthsValue !== null && typeof monthsValue !== 'undefined' && monthsValue !== '';
    var months = hasMonths ? Number(monthsValue) : 0;
    var parts = [];

    if (years > 0) parts.push(years + (years === 1 ? ' year' : ' years'));
    if (months > 0) parts.push(months + (months === 1 ? ' month' : ' months'));
    if (!parts.length && years === 0 && !hasMonths) return 'Under 1 year (months not provided)';
    if (!parts.length) return '0 months';
    return parts.join(', ');
  }

  function formatNumber(value, decimals) {
    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals
    });
  }

  function capitalize(value) {
    var text = String(value || '');
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
})();
